module.exports = __webpack_public_path__ + "static/img/cek.bdb2d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cek.png
// module id = oGQH
// module chunks = 1